import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export const requestJoinGroup = createAction(`${actionKey}.REQUEST_JOIN`, (group)=>({
        group
    }));
export const requestLeaveGroup = createAction(`${actionKey}.REQUEST_LEAVE`, (group)=>({
        group
    }));
export const groupJoinSuccess = createAction(`${actionKey}.JOIN_SUCCESS`, (group)=>({
        group
    }));
export const groupJoinFail = createAction(`${actionKey}.JOIN_FAIL`, (group, error)=>({
        group,
        error
    }));
export const groupJoinPending = createAction(`${actionKey}.JOIN_PENDING`, (group)=>({
        group
    }));
export const groupLeaveSuccess = createAction(`${actionKey}.LEAVE_SUCCESS`, (group)=>({
        group
    }));
export const groupLeaveFail = createAction(`${actionKey}.LEAVE_FAIL`, (group, error)=>({
        group
    }));
